import React, {useEffect, useState} from 'react';
import {DetailGrid, Utility} from '@/components/GridWidget';
import {WdiCardTitle, WdiModalProps} from '@/components/WdiControls';
import {Button} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import PrePaymentDetailEditApp from "@/pages/sales/sp/PrePaymentApply/components/detail/PrePaymentDetailEditApp";
import DataStore from "@/components/GridWidget/DataStore";

export type DetailForApplyProps = {
  getFormSp: ()=>API.FormSpPreVo
  dataSource: any[],
  onChange?: (dataSource: API.FormSpPreDetailVo[]) => void;
}

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
};

const PrePaymentDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});
  const {dataSource} = props

  useEffect(() => {
    GridApi.searchConfig({
      id:'FormSPDetailForPreGeneral',
      allowModifyColumns: false
    }).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);

      settings.formSchema.allFields.rowNumber.width = 80;

      Utility.setActionCallback(
        settings.formSchema.actions,
        'Update',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setModalProps({
            visible: true,
            title: '编辑费用明细',
            type: ModalAppTypeEnums.Edit,
            id: null,
            data: {
              formSpDetails: context.dataSource,
              rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
              record: record,
            }
          });
        },
      );


      Utility.setActionCallback(
        settings.formSchema.actions,
        'SystemDelete',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          if (window.confirm("确定要删除此费用信息吗？")) {
            props.onChange?.(DataStore.del(context.dataSource,record.uid))
          }
        },
      );
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
  };


  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        extra={
          <>
            <Button
              type='primary'
              onClick={() => {
                setModalProps({
                  title: '新建费用明细',
                  visible: true,
                  type: ModalAppTypeEnums.Insert,
                  data: {formSpDetails: dataSource,rowIndex:-1}
                })
              }}
              style={{float: 'right', marginRight: 10}}>
              新建
            </Button>
          </>
        }
      >
        {isLoaded && <DetailGrid {...pageGridSettings} autoColumn={['rowNumber']}/>}
      </WdiPanel>
      {modalProps?.type && [ModalAppTypeEnums.Insert,ModalAppTypeEnums.Edit].includes(modalProps.type) &&
        <PrePaymentDetailEditApp
          {...modalProps}
          getFormSp={props.getFormSp}
          onClose={()=>setModalProps({visible:false})}
          onSave={(result)=> {
            if(!result?.data){
              return;
            }
            if(ModalAppTypeEnums.Insert == modalProps.type){
              props.onChange?.(DataStore.add(dataSource,result.data));
            }
            if(ModalAppTypeEnums.Edit == modalProps.type){
              props.onChange?.(DataStore.edit(dataSource,result.data))
            }
            setModalProps({visible:false});
          }}

        />
      }
    </>
  );
}
export default PrePaymentDetailsForApplyPanel;
